import React, { useEffect } from 'react';
import { useAnalyticsOverview } from '../../services/analytics';
import WelcomeWidget from '../../components/dashboard/WelcomeWidget';
import FreePlanNotice from '../../components/dashboard/FreePlanNotice';

const DashboardHomePage: React.FC = () => {
  const { refetch } = useAnalyticsOverview();

  useEffect(() => {
    const interval = setInterval(() => {
      refetch();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [refetch]);

  return (
    <div data-testid="dashboard-home-page">
      {/* Above the hero on purpose: a new workspace lands on Free with no idea
          it did, and this is the first thing it should read. Renders nothing
          once dismissed, on a paid plan, or without billing access. */}
      <FreePlanNotice />

      {/* Product rule 2026-07-20: the Dashboard is the one page WITHOUT a
          title — its welcome hero is the header. */}
      <WelcomeWidget />
    </div>
  );
};

export default DashboardHomePage;
